import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextarea } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { GoogleMapsModule } from '@angular/google-maps';
import { AccordionModule } from 'primeng/accordion';
import { PanelModule } from 'primeng/panel';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { PublicLegalRoutingModule } from './public-legal-routing.module';
import { PublicLegalInfoComponent } from './info/info.component';
import { PublicLegalTermsComponent } from './terms/terms.component';

@NgModule({
    declarations: [
        PublicLegalInfoComponent,
        PublicLegalTermsComponent
    ],
    imports: [
        CoreModule,
        CommonModule,
        PublicLegalRoutingModule,
        CardModule,
        ButtonModule
    ]
})
export class PublicLegalModule { }
